import { WritableDraft } from 'immer/dist/internal.js';
import { SubmissionCategory } from '../types/global/helper';

export function extractSymbolAndValue(formatted: string): { symbol: string; value: number } {
    const match = formatted.match(/^([^\d\s]+)?([\d,.]+)/); // cleaned up \.
    if (!match) throw new Error(`Invalid formatted value: ${formatted}`);
    const symbol = match[1] || '';
    const value = parseFloat(match[2].replace(/,/g, ''));
    return { symbol, value };
}

export function updateCategoryPricing(
    category: WritableDraft<SubmissionCategory>,
    discountAmount: number,
    remove: boolean = false,
    isFixedAmount: boolean = false,
): SubmissionCategory {
    const updatedCategory: SubmissionCategory = { ...category };

    const originalBareAmount = category.original_price * category.rate;
    const { symbol: feeSymbol, value: originalFeeValue } = extractSymbolAndValue(category.fee!);

    if (remove) {
        return updatedCategory;
    }

    // Calculate discounted USD
    const discountValueUSD = isFixedAmount ? discountAmount : (category.original_price * discountAmount) / 100;

    const discountedUSD = category.original_price - discountValueUSD;
    const discountedBareAmount = discountedUSD * category.rate;
    const discountValue = originalBareAmount - discountedBareAmount;
    const priceRatio = discountedBareAmount / originalBareAmount;

    updatedCategory.bare_amount = discountedBareAmount;
    updatedCategory.discounted_price = `${feeSymbol}${discountValue.toLocaleString()}`;

    const updatedFeeAmount = originalFeeValue * priceRatio;
    updatedCategory.fee = `${feeSymbol}${updatedFeeAmount.toLocaleString()}`;

    return updatedCategory;
}
